import plans from './plans'
import sites from './sites'
import staticPages from './static'

export default {
  plans,
  sites,
  static: staticPages
}
